module.exports = __webpack_public_path__ + "img/paypal.7b8c5e4b.png";